const config = {
  API_URL: 'https://integrasi.big.go.id/api',
  RECAPTCHA_SITE_KEY: '6Lc8R1UrAAAAAOhsjuAIA034_c0OR6samc6OGtA7',
};

export default config;